<template>
	<v-dialog
		v-model="showDialog"
		max-width="1200px"
		:fullscreen="$vuetify.breakpoint.mdAndDown ? true : false"
		:transition="$vuetify.breakpoint.mdAndDown ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.mdAndDown">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">見積詳細</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-sheet class="pa-2" elevation="0">
				<v-row no-gutters justify="end">
					<v-btn color="secondary" @click="openMatterDialog">
						<v-icon class="mr-1">mdi-information-outline</v-icon>
						案件情報を確認する
					</v-btn>
					<v-btn
						class="ml-2"
						color="secondary"
						@click="$router.push({ name: 'quotation_edit', params: { id } })"
					>
						<v-icon class="mr-1">mdi-pencil</v-icon>
						編集する
					</v-btn>
					<v-btn
						class="ml-2"
						color="secondary"
						@click="$router.push({ name: 'quotation_show', params: { id } })"
					>
						<v-icon class="mr-1">mdi-file-document-outline</v-icon>
						印刷する
					</v-btn>
					<QuotationSubmitDialog
						:quotation="quotation"
						:status="quotation.status_i18n"
						@submit-quotation="submitQuotation($event)"
					/>
				</v-row>
				<!-- TODO authorityによる表示 -->
				<ConfirmationSection
					:name="'見積'"
					:actionName="'承認'"
					:requiredConfirmationDialog="false"
					@accept="confirmationDialog = true"
					@reject="rejectQuotation($event)"
				/>

				<v-row no-gutters>
					<v-col cols="12" lg="6" class="pr-lg-2">
						<table width="100%" class="mt-4 show-dialog-table">
							<!-- TODO valueをサンプルデータから変更 -->
							<tbody>
								<ShowDetailRecord :columnName="'見積承認日'" :value="'2023/05/01'" />
								<ShowDetailRecord :columnName="'見積提出日'" :value="'2023/05/03'" />
								<ShowDetailRecord :columnName="'見積先'" :value="'西田鉄工(株)'" />
								<ShowDetailRecord :columnName="'客先照会番号'" :value="'12345678'" />
								<ShowDetailRecord :columnName="'客先照会日付'" :value="'2020/01/01'" />
								<ShowDetailRecord :columnName="'納品場所'" :value="'山梨県飽海郡遊佐町東口道上'" />
								<ShowDetailRecord :columnName="'納期'" :value="'2023/09/01'" />
								<ShowDetailRecord :columnName="'支払い条件'" :value="'従来通り'" />
								<ShowDetailRecord :columnName="'見積有効期限'" :value="'2023/06/01'" />
								<ShowDetailRecord :columnName="'客先名'" :value="'(株)湊製作所'" />
								<ShowDetailRecord :columnName="'納入先名'" :value="'西田鉄工(株)'" />
								<ShowDetailRecord :columnName="'工事名'" :value="'-'" />
								<ShowDetailRecord :columnName="'品名'" :value="'ゴム伸縮継手'" />
								<ShowDetailRecord
									:columnName="'見積条件'"
									:value="'※ 見積仕様条件は、別紙明細書通りとします。'"
								/>
								<ShowDetailRecord :columnName="'添付資料'">
									<template v-slot:value>
										<v-row no-gutters class="flex-nowrap">
											<a :href="''" target="_blank"> ファイル.pdf </a>
										</v-row>
									</template>
								</ShowDetailRecord>
							</tbody>
						</table>
					</v-col>
					<v-col cols="12" lg="6" class="pl-lg-2">
						<!-- <div v-for="(matter_product, i) in quotation.matter.matter_products" :key="i">
							<h6 class="font-weight-bold text-body-1">製品{{ i + 1 }}</h6>
							<table width="100%" class="mt-4 show-dialog-table">
								<tbody>
									<ShowDetailRecord :columnName="'品名'" :value="''" />
									<ShowDetailRecord :columnName="'寸法'" :value="''" />
									<ShowDetailRecord :columnName="'数量'" :value="''" />
									<ShowDetailRecord :columnName="'単位'" :value="''" />
									<ShowDetailRecord :columnName="'単価'" :value="''" />
									<ShowDetailRecord :columnName="'適応(型式)'" :value="''" />
								</tbody>
							</table>
						</div> -->

						<!-- TODO 画面レイアウト用 削除 -->
						<h6 class="font-weight-bold text-body-1 mt-4">製品1</h6>
						<table width="100%" class="mt-2 show-dialog-table">
							<tbody>
								<ShowDetailRecord :columnName="'品名'" :value="'ゴム伸縮継手'" />
								<ShowDetailRecord :columnName="'寸法'" :value="'1800A × 900L'" />
								<ShowDetailRecord :columnName="'数量'" :value="'3'" />
								<ShowDetailRecord :columnName="'単位'" :value="'基'" />
								<ShowDetailRecord :columnName="'単価'" :value="'1,880,000'" />
								<ShowDetailRecord :columnName="'適応(型式)'" :value="'DMⅡ100M'" />
							</tbody>
						</table>
					</v-col>
				</v-row>
			</v-sheet>
		</v-card>
		<QuotationConfirmDialog
			:dialog.sync="confirmationDialog"
			:quotation="quotation"
			:actionText="'承認'"
			:matter="quotation.matter"
			@submit-form="approveQuotation()"
		/>
	</v-dialog>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"
import ConfirmationSection from "../../shared/ConfirmationSection.vue"
import QuotationSubmitDialog from "./QuotationSubmitDialog.vue"
import QuotationConfirmDialog from "./QuotationConfirmDialog.vue"

export default {
	props: {
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
		id: {
			type: Number,
			required: false,
			default: null,
		},
		authority_flag: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	components: {
		ShowDetailRecord,
		ConfirmationSection,
		QuotationSubmitDialog,
		QuotationConfirmDialog,
	},
	data() {
		return {
			quotation: {
				matter: {
					matter_products: [],
				},
			},
			confirmationDialog: false,
			common,
			rules,
		}
	},
	methods: {
		fetchQuotation(id) {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/quotations/${id}`
			axios
				.get(url, { headers })
				.then((res) => {
					this.quotation = res.data.quotation
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		openMatterDialog() {
			// TODO MatterShowDialogを開く
		},
		submitQuotation() {
			// TODO Quotationを提出状態に変更する
		},
		rejectQuotation(reason) {
			// TODO Quotationを差し戻し状態に変更する
		},
		approveQuotation() {
			// TODO Quotationを承認または確認状態に変更する
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
	watch: {
		id(newVal, oldVal) {
			if (newVal == oldVal) return
			this.fetchQuotation(newVal)
		},
		deep: true,
	},
}
</script>